import React, { FC } from 'react'
import { observer } from 'mobx-react'
import { Header } from '../../components/Header/Header'
import { ContentWrap, Footer, Page, StepLine } from './StepsPage.styles'
import { StepsPageMobile } from './StepsPageMobile'

const proxy_url = 'https://identity-api1.prod-d.signicat.global/'

export const StepsPage: FC = observer(() => {
  return (
    <>
      <StepsPageMobile proxyUrl={proxy_url} />
      <Page>
        <Header />
        <ContentWrap>
          <h1>Become a customer in 4 easy steps</h1>

          <StepLine>
            <div>1</div>
            <span>Consent and share your personal information (PII)</span>
          </StepLine>

          <StepLine>
            <div>2</div>
            <span>Review the document</span>
          </StepLine>

          <StepLine>
            <div>3</div>
            <span>Complete the signing process with identification</span>
          </StepLine>

          <StepLine>
            <div>4</div>
            <span>Micropayment transfer of 0,01€</span>
          </StepLine>
          <Footer>
            <a href={proxy_url}>Continue</a>
          </Footer>
        </ContentWrap>
      </Page>
    </>
  )
})
